import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { sendOneDayPassword, sendPasswordUrl, setLoginPassword } from '../../../redux/Actions';
import Alert from '../../common/Alert';
import TermConditionModal from '../../common/TermConditionModal';
import ForgotPasswordMessage from './ForgotPasswordMessage';
import LoginForm from './LoginForm';
import ResendOTPMessage from './ResendOTPMessage';
import SuccessAndErrorModal from '../../common/SuccessAndErrorModal';
import { LoginSuccessAndErrorMsg } from './constants';
import CustomizedDialogs from '../../common/CustomizedDialogs';
import { Box } from '@mui/material';
import OneDayPassword from './OneDayPassword';
import ForgotPasswordModal from './forgotPassword/forgotPasswordModal';
import { strongPassword } from '../../../utilityFunctions';
import moment from 'moment';

const Login = (props) => {
    const { fetchLogin, error, setError, setShowLoginId, passwordReset, setPasswordReset, loginError, setLoginError, updateOdp, setUpdateOdp, callLoginApi } = props
    const user = useSelector((store) => store?.user);
    const dispatch = useDispatch()
    const [formType, setFormType] = useState("login");
    const [heading, setHeading] = useState("AWATAR 4.0");
    const [resendOtp, setResendOtp] = useState(false)
    const [forgotPasswordOtp, setForgotPasswordOtp] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [termCondition, setTermCondition] = useState(true)
    const [loginId, setLoginId] = useState("")
    const [showAlert, setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");


    const DailogMessage = () => (
        <div className="agentDialogWrap">
            <div className="agentSvg">
                You need to agree to KSRTC's

            </div>
            <div className="agentMessage">
                <span style={{ color: "#004F9E", textDecoration: "underline", fontSize: "14px" }}>Terms & Conditions</span> <span style={{ fontSize: "14px" }}>and</span>  <span style={{ color: "#004F9E", textDecoration: "underline", fontSize: "14px" }}>Privacy Policy</span>
            </div>
        </div>
    )

    const handleTermCon = (val) => {
        if (val) {
            setTermCondition(true)
            setShowDeleteModal(false)
        } else {
            setShowDeleteModal(false)
        }
    }
    const sendODP = (UserLoginId, showModal = false) => {
        if (UserLoginId == "") {
            setShowAlert(true)
            setAlertMsg("Enter User ID")
        } else {
            const body = {
                LoginID: UserLoginId,
            }
            dispatch(sendOneDayPassword("/LoginV2/GetOneDayPassword", body)).then((res) => {
                if (res?.data?.status === true) {
                    if (showModal) {
                        setUpdateOdp((prev) => ({
                            ...prev,
                            ...passwordReset,
                            open: true,
                        }))
                    } else {
                        setResendOtp(true)
                    }
                } else {
                    setShowAlert(true)
                    setAlertMsg(res.data.Message)
                }
            }).catch((error) => {
                console.log("Error: ", error);
            });
        }
    }

    const sendPassword = () => {
        if (loginId == "") {
            setShowAlert(true)
            setAlertMsg("Enter User ID")
        } else {
            const body = {
                LoginID: loginId,
                RequestedUserID: 0
            }
            dispatch(sendPasswordUrl("/LoginV2/SendPasswordLink", body)).then((res) => {
                if (res?.data?.status === true) {
                    // setResendOtp(true)
                    setForgotPasswordOtp(true)
                } else {
                    setShowAlert(true)
                    setAlertMsg(res.data.Message)
                }
            }).catch((error) => {
                console.log("Error: ", error);
            });
        }
        // 
    }
    const handleUpdatePassword = (values) => {
        if (values.newPassword?.trim() === '') {
            setAlertMsg('Enter New Password')
            setShowAlert(true)
        } else if (values.ConfirmPassword?.trim() === '') {
            setAlertMsg('Enter confirm Password')
            setShowAlert(true)
        } else if (values.newPassword !== values.ConfirmPassword) {
            setAlertMsg('Password and confirm password should be equal')
            setShowAlert(true)
        } else if (!strongPassword(values.newPassword)) {
            setAlertMsg('A minimum 8 characters password contains a combination of \nspecial character,uppercase and lowercase letter and number\n are required.')
            setShowAlert(true)
        } else if (values.newPassword === passwordReset?.oldPassword) {
            setAlertMsg('Old password and new password should not be same')
            setShowAlert(true)
        } else {
            const body = {
                LoginID: passwordReset.LoginID,
                Password: values.newPassword
            }
            dispatch(setLoginPassword("/LoginV2/SetPassWord", body)).then((res) => {
                if (res.status === 200) {
                    setLoginError({
                        value: true,
                        isError: false,
                        msg: 'Your expired password has been successfully updated. You can now log in with your new password.'
                    })
                    sessionStorage.clear();
                    setPasswordReset((prev) => ({
                        ...prev,
                        oldPassword: '',
                        open: false,
                        GUID: '',
                        LoginID: '',
                        Password: '',
                        ODP: '',
                    }))
                } else {
                    setLoginError({
                        value: true,
                        isError: true,
                        msg: res.Message
                    })
                }
            }).catch((err) => {
                console.log('Error:', err)
            })
        }
    }
    const handleUpdateODP = (values) => {
        const body = {
            ...updateOdp,
            ODP: values?.ODP
        }
        callLoginApi(body)
    }
    return (
        <>
            <div className='container'>
                <div className="login-page">
                    <div className="left--part">
                        <div className="login--wrapper">
                            <div className='login--logo--wrapper' key='login-header-logo'>
                                <img key='company-logo' src="/images/headerLogo1.png" style={{ width: '300px' }} alt="Karnataka State Road Transport Corporation" /></div>
                            <div className="head--txt">{heading}</div>
                            {
                                resendOtp ? <ResendOTPMessage setResendOtp={setResendOtp} /> :
                                    forgotPasswordOtp ? <ForgotPasswordMessage setForgotPasswordOtp={setForgotPasswordOtp} /> :
                                        <>
                                            {formType === 'login' ? <LoginForm termCondition={termCondition} setShowLoginId={setShowLoginId} setLoginId={setLoginId} setShowDeleteModal={setShowDeleteModal} error={error} setError={setError} fetchLogin={fetchLogin} setHeading={setHeading} /> : <></>}
                                        </>
                            }
                            {
                                !(resendOtp || forgotPasswordOtp) &&
                                <div className="forgotPassText">
                                    <span onClick={() => sendPassword()}>Forgot Password?</span>
                                    <span onClick={() => sendODP(loginId)}>Resend ODP</span>
                                </div>
                            }
                            <div className='termCon'>
                                <label>
                                    <input name="" type="checkbox" disabled={true} value="" checked={termCondition} onChange={(e) => setTermCondition(e.target.checked)} />
                                    <span>
                                        You agree to KSRTC <span className='blueColor' style={{ cursor: 'pointer' }} onClick={() => {
                                            window.open('https://ksrtc.in/reservation_terms', '_blank', 'noopener,noreferrer')
                                        }} >Terms & Conditions</span>
                                    </span>
                                </label>
                            </div>
                            <div className='ipAddress'>
                                <span>Your IP Address: {user?.ipAddress || ''}</span>
                            </div>
                            <div className='captcha-box'>
                                <img src="/images/captcha.svg" alt="" />

                            </div>
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                            {/* <label style={{ fontSize: "12px", display: "flex", alignItems: "center", gap: "15px" }}>
                        <span>
                            <input style={{ height: "16px", width: "16px" }} name="" type="checkbox" value="" checked="checked" />
                        </span>
                        <span>
                            You agree to our
                            <span style={{ color: '#004F9E', textDecoration: "underline" }}> Terms of Use</span>
                            <span>agreement and</span>
                            <span style={{ color: '#004F9E', textDecoration: "underline" }}>  Privacy Policy</span>
                        </span>
                    </label> */}
                        </div>
                    </div>
                    <div className="right--part">
                        <div className="right-box">
                            <h4>Please note the following:</h4>
                            <ol>
                                <li>
                                    Profile password is the password you created for your user profile and is unique to your profile. In case you have forgotten the same, use forgot profile password to create a new one.
                                </li>
                                <li>
                                    One Day Password or ODP is a single day usage password automatically generated and sent on your registered email id and mobile number. For any reason, if you don't have the same, you can request the ODP again using Resend ODP.
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="copy--right--txt">
                    <p>&copy; {new Date().getFullYear()} Karnataka State Road Transport Corporation | Powered by Amnex Infotechnologies Private Limited & Mantis Technologies Private Limited</p>
                </div>
            </div>
            <TermConditionModal open={showDeleteModal} width={"328px"} showTitle={false} onClose={handleTermCon} dialogConfirmationMessage={<DailogMessage />} />
            <SuccessAndErrorModal zIndex='9999' open={loginError?.value}
                dialogConfirmationMessage={
                    <LoginSuccessAndErrorMsg isError={loginError?.isError} message={loginError?.msg} />
                }
                onClose={() => {
                    setLoginError({
                        value: false,
                        isError: false,
                        msg: ''
                    })
                }}
            />
            <CustomizedDialogs open={updateOdp?.open} onClose={false}
                padding={'0px'}
                zIndex='1000'
            >
                <OneDayPassword data={updateOdp} onClose={() => {
                    setUpdateOdp((prev) => ({
                        ...prev,
                        open: false,
                        LoginID: '',
                        Password: '',
                        ODP: '',
                        GUID: '',
                        phone:"",
                        email:"",
                    }))
                }}
                    onSubmit={(data) => {
                        handleUpdateODP(data)
                    }}
                />
            </CustomizedDialogs>
            <CustomizedDialogs open={passwordReset?.open} onClose={false}
                padding={'0px'}
            >
                <ForgotPasswordModal titleName={'Update your Expired Old Password'} data={passwordReset} onClose={() => {
                    setPasswordReset((prev) => ({
                        ...prev,
                        oldPassword: '',
                        open: false,
                        GUID: '',
                        LoginID: '',
                        Password: '',
                        ODP: '',
                    }))
                }}
                    onSubmit={(data) => {
                        handleUpdatePassword(data)
                    }}
                />
            </CustomizedDialogs>
            {showAlert && <Alert msg={alertMsg} alertType={"error"} close={() => setShowAlert(false)} buttonText="Ok" />}
        </>
    );
}

export default Login